import { render, staticRenderFns } from "./CommentLog.vue?vue&type=template&id=ae1130ee"
import script from "./CommentLog.vue?vue&type=script&lang=js"
export * from "./CommentLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports